import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useLoader from '../../../common/hooks/Loader';
import { getRegistryCountAction } from '../../api';
import GradientEvent from '../../components/assets/Gradient-events.png';
import GradientJourney from '../../components/assets/Gradient-journey.png';
import GradientService from '../../components/assets/Gradient-services.png';
import { CountStructure, TotalCountForAllEventServiceJourney, TypeOfCard } from '../../components/utility/type-defs';
import DescriptionText from '../Card/DescriptionText';
import JourneyCard from '../Card/JourneyCard';
import MainHeader from '../Header/MainHeader';
import CreateButtonSubHeader from '../SubHeader/CreateButtonSubHeader';
import classes from './DashboardMain.module.scss';

const DashboardMain = () => {
  const { t: translate } = useTranslation();
  const [journeyCount, setJourneyCount] = useState<CountStructure>();
  const [eventCount, setEventCount] = useState<CountStructure>();
  const [servicesCount, setServicesCount] = useState<CountStructure | object>();
  const loader = useLoader();
  useEffect(() => {
    loader.show();
    (async () => {
      const resp = await getRegistryCountAction();
      loader.hide();

      if (!resp?.length) return;

      const registryCount = resp[0];
      const keys: Array<keyof TotalCountForAllEventServiceJourney> = ['events', 'services', 'journeys'];
      const setters = [setEventCount, setServicesCount, setJourneyCount];

      keys.forEach((key, index) => {
        const count: CountStructure = registryCount[key];
        if (Object.keys(count).length) {
          setters[index](count);
        }
      });
    })();
  }, []);

  return (
    <div className={classes.wrapper} data-testid="common-dashboard-container">
      <div className={classes['maincontent-title']}>
        <MainHeader />
      </div>
      <div>
        <CreateButtonSubHeader />
      </div>
      <div>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={3}><DescriptionText /></Col>
          {servicesCount !== undefined ? <Col xs={12} sm={12} md={6} lg={4} xl={3}><img src={GradientService} className={classes['gradient-image']} alt="gradient-service" data-testid="" /><JourneyCard counts={servicesCount as CountStructure} typeOfCard={TypeOfCard.SERVICE} /></Col> : <div className={classes['error-msg']}>{translate('main_header_component.error_message_service')}</div>}
          {eventCount !== undefined ? <Col xs={12} sm={12} md={6} lg={4} xl={3}><img src={GradientEvent} className={classes['gradient-image']} alt="gradient-event" /><JourneyCard counts={eventCount} typeOfCard={TypeOfCard.EVENT} /></Col> : <div className={classes['error-msg']}>{translate('main_header_component.error_message_events')}</div>}
          {journeyCount !== undefined ? <Col xs={12} sm={12} md={6} lg={4} xl={3}><img src={GradientJourney} className={classes['gradient-image']} alt="gradient-journey" /><JourneyCard counts={journeyCount} typeOfCard={TypeOfCard.JOURNEY} /></Col> : <div className={classes['error-msg']}>{translate('main_header_component.error_message_journeys')}</div>}
        </Row>
      </div>
    </div>
  );
};

export default DashboardMain;
